'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withStyles = require('../with-styles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RichText = function RichText(_ref) {
  var children = _ref.children,
      Tag = _ref.tag,
      classNames = _ref.classNames;

  if (!children) {
    return null;
  }

  return _react2.default.createElement(
    Tag,
    { className: 'c11n-rich-text ' + classNames.root },
    typeof children === 'string' ? _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: children } }) : children
  );
};

RichText.propTypes = {
  /**
   * The html to be structured
   */
  children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.element), _propTypes2.default.element]),

  /**
   * The tag to be used for the containing element
   */
  tag: _propTypes2.default.string,

  /**
   * The base font size to use
   */
  size: _propTypes2.default.number,

  /**
   * The number of lines to clamp
   */
  lineClamp: _propTypes2.default.number,

  /**
   * Custom styles to be added to the element
   */
  styles: _propTypes2.default.object
};

RichText.defaultProps = {
  size: 0,
  styles: {},
  tag: 'div'
};

exports.default = (0, _withStyles2.default)(_styles2.default)(RichText);


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/rich-text/index.js
// module id = 235
// module chunks = 0